import React from 'react';
import { useMedia } from 'react-use';
import useWebPCheckSupport from '@ts/utils/useWebPCheckSupport';
import * as S from './styles';

const Carousel = ({ children, images }) => {
    const notVisible = useMedia('(max-width: 991px)');
    const WebP = useWebPCheckSupport();

    if (notVisible) {
        return null;
    }

    const webpImage = images ? images[1] || images[0].replace(/\.(png|jpg|jpeg)$/i, '.webp') : null;

    return (
        <S.Carousel data-test-id="carousel">
            <React.Fragment>{children}</React.Fragment>
            <React.Fragment>
                {Array.isArray(images) && (
                    <React.Fragment>
                        <div data-test-id="slides">
                            <S.Slide image={WebP ? webpImage : images[0]} />
                        </div>
                    </React.Fragment>
                )}
            </React.Fragment>
        </S.Carousel>
    );
};

export default Carousel;
